'use es6';

import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Toolbar(props) {
  return /*#__PURE__*/_jsx(UIButtonGroup, Object.assign({
    orientation: "vertical"
  }, props));
}